module.exports = __webpack_public_path__ + "static/img/主图.97c7be1.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/match_result/figure/结果页/爱自己/田野/主图.png
// module id = DspQ
// module chunks = 1